const COORD_PRECISION = 6
const PRECISION_FACTOR = 10 ** COORD_PRECISION
const roundCoord = (n: number) => Math.round(n * PRECISION_FACTOR) / PRECISION_FACTOR

export function roundLatLng(point?: { lat: number, lng: number }) {
  if (!point) return

  return {
    lat: roundCoord(point.lat),
    lng: roundCoord(point.lng),
  }
}
